import { render, staticRenderFns } from "./businessBidSituation.vue?vue&type=template&id=2b6e03fe&scoped=true"
import script from "./businessBidSituation.vue?vue&type=script&lang=js"
export * from "./businessBidSituation.vue?vue&type=script&lang=js"
import style0 from "./businessBidSituation.vue?vue&type=style&index=0&id=2b6e03fe&prod&lang=scss&scoped=true"
import style1 from "./businessBidSituation.vue?vue&type=style&index=1&id=2b6e03fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e03fe",
  null
  
)

export default component.exports